// extracted by mini-css-extract-plugin
export default {"root":"styles_root__XgrDF","edit-overlay":"styles_edit-overlay__8w3Fa","editOverlay":"styles_edit-overlay__8w3Fa"};